import { ThemeProvider } from "@mui/material";
import AppRouter from "./routes";
import customTheme from "./mui/theme/theme";
import { RecruiterDetailsResponse } from "./types";
import FilterProvider from "./pages/FolderManagement/context/FilterContext";
import { getUserDetails } from "./utils/getUserDetails";
import { useEffect, useState } from "react";
import ToastMessage from "./components/common/toast-message/toast-message";
import "../node_modules/@foundit/header/dist/HeaderWeb.css";
function App() {
  const [showNotificationToast, setShowNotificationToast] = useState<boolean>(false);
  const [notificationToastMessage, setNotificationToastMessage] = useState<string>("");
  const [processing, setProcessing] = useState<boolean>(false);
  const [processingToastMessage, setProcessingToastMessage] = useState<string>("");
  const [error, setError] = useState<boolean>(false);
  const [errorToastMessage, setErrorToastMessage] = useState<string>("");
  const [userDetails, setUserDetails] = useState<RecruiterDetailsResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchUserDetails = () => {
    const details = getUserDetails();
    if (details && Object.keys(details).length > 0) {
      setUserDetails(details);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!userDetails?.recruiter_id) {
        fetchUserDetails();
      } else {
        clearInterval(intervalId);
      }
    }, 100);
    return () => clearInterval(intervalId);
  }, [userDetails]);

  const getGtmValue = (siteContext: string | undefined) => {
    switch (siteContext) {
      case "monstergulf":
        return "GTM-TGMWFHT";
      case "monstersingapore":
        return "GTM-WXW3G7";
      case "monsterthailand":
        return "GTM-W4XCF74";
      case "monsterphilippines":
        return "GTM-NCB6SR";
      case "monstervietnam":
        return "GTM-TJ7F7ZH";
      case "monstermalaysia":
        return "GTM-57CQ4N";
      case "monsterindonesia":
        return "GTM-MGZV4PL";
      case "monsterhongkong":
        return "GTM-KWGPLKK";
      case "rexmonster":
        return "GTM-NGL6ZM";
      default:
        return "";
    }
  };

  useEffect(() => {
    if (userDetails) {
      const noscriptElement = document.createElement("noscript");
      const iframeElement = document.createElement("iframe");
      iframeElement.src = `https://www.googletagmanager.com/ns.html?id=${getGtmValue(
        userDetails?.site_context
      )}`;
      iframeElement.height = "0";
      iframeElement.width = "0";
      iframeElement.style.display = "none";
      iframeElement.style.visibility = "hidden";
      noscriptElement.appendChild(iframeElement);
      document.body.insertBefore(noscriptElement, document.body.firstChild);

      const scriptElement = document.createElement("script");
      scriptElement.innerHTML = `
        (function(w,d,s,l,i){
          w[l]=w[l]||[];
          w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
          j.async=true;
          j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
          f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer', '${getGtmValue(
          userDetails?.site_context
        )}');
      `;
      document.head.appendChild(scriptElement);
    }
  }, [userDetails?.recruiter_id]);

  const onNotificationToast = (message: string) => {
    setNotificationToastMessage(message);
    setShowNotificationToast(true);
  };

  const onProcessingToast = (message: string, status: boolean) => {
    setProcessingToastMessage(message);
    setProcessing(status);
  };
  const onErrorToast = (message: string) => {
    setErrorToastMessage(message);
    setError(true);
  };

  if (isLoading) {
    return <></>;
  }

  if (userDetails && Object.keys(userDetails).length > 0) {
    return (
      <ThemeProvider theme={customTheme}>
        {showNotificationToast && (
          <ToastMessage
            showToastMessage={showNotificationToast}
            message={notificationToastMessage}
            toastSeverity="info"
            handleToastClose={() => setShowNotificationToast(false)}
            shouldAutoHide={false}
          />
        )}
        {processing && (
          <ToastMessage
            showToastMessage={processing}
            message={processingToastMessage}
            toastSeverity="info"
            handleToastClose={() => setProcessing(false)}
            shouldAutoHide={false}
          />
        )}
         {error && (
          <ToastMessage
            showToastMessage={error}
            message={errorToastMessage}
            toastSeverity="error"
            handleToastClose={() => setProcessing(false)}
            shouldAutoHide={false}
          />
        )}
        <FilterProvider>
          <AppRouter
            onNotificationToast={onNotificationToast}
            onProcessingToast={onProcessingToast}
            onErrorToast={onErrorToast}
          />
        </FilterProvider>
      </ThemeProvider>
    );
  }
  return <></>;
}

export default App;
